import { render, staticRenderFns } from "./address-list-modal.vue?vue&type=template&id=b04958b0&scoped=true&"
import script from "./address-list-modal.vue?vue&type=script&lang=js&"
export * from "./address-list-modal.vue?vue&type=script&lang=js&"
import style0 from "./address-list-modal.vue?vue&type=style&index=0&id=b04958b0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04958b0",
  null
  
)

export default component.exports